<template>
    <div>
        <carousel 
            :scrollPerPage="true" 
            :perPageCustom="[[360, 1], [768, 2]]" 
            :autoplay="true" 
            :speed="1000" 
            :autoplayTimeout="4000" 
            :loop="true" 
            :paginationEnabled="true" 
            :navigationEnabled="true"
            :centerMode="true"
            :paginationActiveColor="colors.primary"
            paginationColor="#666666"
            :navigationNextLabel="navigationNext"
            :navigationPrevLabel="navigationPrev"
        >
            <slide v-bind:key="key" v-for="(value, key) of this.lastNews" data-name="newsSlider">
                <div class="slick-slide-item">
                    <div class="row blog-2 shadow-none">
                        <div class="col-lg-5 col-md-12 col-pad">
                            <div class="photo">
                                <img v-bind:src="value.cover.sizes['512']" :alt="value.cover.alt" class="img-fluid fit-cover h-100">
                            </div>
                        </div>
                        <div class="col-lg-7 col-md-12 col-pad">
                            <div class="detail">
                                <h3>
                                    <a :href="'/news/' + value.slug">{{ truncateTitle(value.title) }}</a>
                                </h3>
                                <p class="news-abstract">{{ value.abstract }}</p>
                                <a :href="'/news/' + value.slug" class="read-more">Leggi tutto</a>
                            </div>
                        </div>
                    </div>
                </div>
            </slide>
        </carousel>
    </div>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel';

    export default {
        props: ['colors'],
        components: {
            Carousel,
            Slide
        },
        methods: {
            getLastNews() {
               window.axios.get(window.base_url + 'news/latest').then( res => {
                  this.lastNews = res.data.data;
               })
           },
           truncateTitle(title) {
               if(title.length > 42) {
                   return title.substring(0,42)+"...";
               } else {
                   return title;
               }
           }
        },
        mounted() {
           this.getLastNews();
        },
        data() {
            return {
                lastNews: []
            }
        },
        computed: {
            navigationNext: function() { return `<i class="fas fa-chevron-circle-right"></i>` },
            navigationPrev: function() { return `<i class="fas fa-chevron-circle-left"></i>` },
        }
    }
</script>

<style lang="scss" scoped>
    .d-block {
        max-height: 233px;
    }
    .detail {
        padding-top: 10px !important;
        padding-bottom: 10px !important;

        .news-abstract {
            height: 80px;
            overflow: hidden;
        }
    }
    .carousel-indicators {
        padding: 0px !important;
    }
    .photo {
        height: 140px;
    }

    .VueCarousel-slide {
        text-align: left;
    }

    ::v-deep .VueCarousel-navigation-button {
        top: 40% !important;
    }
</style>
